module.exports = __webpack_public_path__ + "img/img_value_1_h190.ea191a52.png";